import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { KnowledgeBaseCategoryEnum } from '@zaoblako/shared/modules/ai/enums/knowledge-base-category.enum';
import { KnowledgeBaseCategoryEnumI18n } from '@zaoblako/shared/modules/ai/i18n/knowledge-base-category-enum.i18n';

@Pipe({
  name: 'knowledgeBaseCategoryName',
  standalone: true
})
export class KnowledgeBaseCategoryNamePipe implements PipeTransform {
  public transform(category: KnowledgeBaseCategoryEnum): string {
    return KnowledgeBaseCategoryEnumI18n[I18nLocalesEnum.RU_RU][category] || '';
  }
}
